import React, { useState } from "react";
import NavAndHero from "../components/NavAndHero";
import Footer from "../components/Footer";
import CallToAction from "../components/CTA";
import { Link } from 'react-router-dom';


const BlogList = () => {
  const posts = [
    // Your blog posts...
    {
      id: 1,
      title: "Why Every Business Needs a Strong Brand Online",
      slug: "why-every-business-needs-a-strong-brand-online",
      date: "April 17, 2025",
      excerpt: "Discover how a memorable brand identity builds trust, drives traffic, and sets your business apart in the digital age.",
    },
    {
      id: 2, 
      title: "How To Build a Brand Identity That Connects", 
      slug: "how-to-build-a-brand-identity-that-connects",
      date: "April 18, 2025", 
      excerpt: "Discover how to craft a meaningful brand identity that builds trust, connects with your audience, and boosts your online visibility."
    }
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;

  const indexOfLast = currentPage * postsPerPage;
  const indexOfFirst = indexOfLast - postsPerPage;
  const currentPosts = posts.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(posts.length / postsPerPage);

  return (
    <div data-theme="light">
      <NavAndHero />

      <section className="bg-base-100 px-6 py-20">
        <div className="max-w-5xl mx-auto space-y-12">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-base">Digiscape Blog</h1>
          <p className="text-center text-gray-500 max-w-2xl mx-auto text-lg">
            Tips, insights, and how-to guides to help you grow online and offline.
          </p>

          <div className="space-y-12">
            {currentPosts.map((post) => (
              <div
                key={post.id}
                className="border border-gray-200 p-6 rounded-lg shadow-sm hover:shadow-md transition"
              >
                <h2 className="text-2xl font-semibold text-blue-500">{post.title}</h2>
                <p className="text-sm text-gray-400 mt-1">{post.date}</p>
                <p className="text-base text-gray-600 mt-4">{post.excerpt}</p>
                <div className="mt-4">
                <Link to={`/blog/${post.slug}`} className="btn btn-primary btn-sm">
                  Read More
                </Link>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center space-x-2 mt-12">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => setCurrentPage(index + 1)}
                className={`btn btn-sm ${
                  currentPage === index + 1 ? "btn-primary" : "btn-ghost"
                }`}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      </section>

      <div id='cta'>
        <CallToAction /> 
      </div>
      <Footer />
    </div>
  );
};

export default BlogList;